import MainPageWrapper from '../../global/components/MainPageWrapper'
import IncidentReportsTable from '../components/table/IncidentReportsTable'

function IncidentReportsMain() {
  return (
    <MainPageWrapper title='Incident Reports'>
      <IncidentReportsTable />
    </MainPageWrapper>
  )
}

export default IncidentReportsMain
